(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unclnch-home"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.uhome').forEach(function (root) {
  var timer = root.querySelector('[data-home-countdown]');
  if (!timer) return;
  var key = 'unclnch-offer-deadline';
  var period = 12 * 60 * 60 * 1000;
  var deadline = Number(localStorage.getItem(key) || 0);
  if (!deadline || deadline <= Date.now() || deadline - Date.now() > period) deadline = Date.now() + period;
  localStorage.setItem(key, String(deadline));
  function tick() {
    var remaining = deadline - Date.now();
    if (remaining <= 0) {
      deadline = Date.now() + period;
      localStorage.setItem(key, String(deadline));
      remaining = period;
    }
    var hours = String(Math.floor(remaining / 3600000)).padStart(2, '0');
    var minutes = String(Math.floor((remaining % 3600000) / 60000)).padStart(2, '0');
    var seconds = String(Math.floor((remaining % 60000) / 1000)).padStart(2, '0');
    timer.textContent = hours + ':' + minutes + ':' + seconds;
  }
  tick();
  window.setInterval(tick, 1000);
});

  } catch(e) { console.error(e); }
})();
})();
